// Mapping of language codes to country codes for flag display
export const languageToCountryMapping: Record<string, string> = {
  'ab': 'GE', // Abkhaz -> Georgia
  'ace': 'ID', // Acehnese -> Indonesia
  'ach': 'UG', // Acholi -> Uganda
  'aa': 'ET', // Afar -> Ethiopia
  'af': 'ZA', // Afrikaans -> South Africa
  'sq': 'AL', // Albanian -> Albania
  'alz': 'UG', // Alur -> Uganda
  'am': 'ET', // Amharic -> Ethiopia
  'ar': 'SA', // Arabic -> Saudi Arabia
  'hy': 'AM', // Armenian -> Armenia
  'as': 'IN', // Assamese -> India
  'av': 'RU', // Avar -> Russia
  'awa': 'IN', // Awadhi -> India
  'ay': 'BO', // Aymara -> Bolivia
  'az': 'AZ', // Azerbaijani -> Azerbaijan
  'ban': 'ID', // Balinese -> Indonesia
  'bal': 'PK', // Baluchi -> Pakistan
  'bm': 'ML', // Bambara -> Mali
  'bci': 'CI', // Baoulé -> Ivory Coast
  'ba': 'RU', // Bashkir -> Russia
  'eu': 'ES', // Basque -> Spain
  'btx': 'ID', // Batak Karo -> Indonesia
  'bts': 'ID', // Batak Simalungun -> Indonesia
  'bbc': 'ID', // Batak Toba -> Indonesia
  'be': 'BY', // Belarusian -> Belarus
  'bem': 'ZM', // Bemba -> Zambia
  'bn': 'BD', // Bengali -> Bangladesh
  'bew': 'ID', // Betawi -> Indonesia
  'bho': 'IN', // Bhojpuri -> India
  'bik': 'PH', // Bikol -> Philippines
  'bs': 'BA', // Bosnian -> Bosnia & Herzegovina
  'br': 'FR', // Breton -> France
  'bg': 'BG', // Bulgarian -> Bulgaria
  'bua': 'RU', // Buryat -> Russia
  'yue': 'HK', // Cantonese -> Hong Kong
  'ca': 'ES', // Catalan -> Spain
  'ceb': 'PH', // Cebuano -> Philippines
  'ch': 'GU', // Chamorro -> Guam
  'ce': 'RU', // Chechen -> Russia
  'ny': 'MW', // Chichewa -> Malawi
  'zh-CN': 'CN', // Chinese (Simplified) -> China
  'zh-TW': 'TW', // Chinese (Traditional) -> Taiwan
  'chk': 'FM', // Chuukese -> Micronesia
  'cv': 'RU', // Chuvash -> Russia
  'co': 'FR', // Corsican -> France
  'crh': 'UA', // Crimean Tatar -> Ukraine
  'hr': 'HR', // Croatian -> Croatia
  'cs': 'CZ', // Czech -> Czech Republic
  'da': 'DK', // Danish -> Denmark
  'fa-AF': 'AF', // Dari -> Afghanistan
  'dv': 'MV', // Dhivehi -> Maldives
  'din': 'SS', // Dinka -> South Sudan
  'doi': 'IN', // Dogri -> India
  'dov': 'MZ', // Dombe -> Mozambique
  'nl': 'NL', // Dutch -> Netherlands
  'dyu': 'BF', // Dyula -> Burkina Faso
  'dz': 'BT', // Dzongkha -> Bhutan
  'eo': 'UY', // Esperanto -> Uruguay
  'en': 'US', // English -> United States
  'et': 'EE', // Estonian -> Estonia
  'ee': 'GH', // Ewe -> Ghana
  'fo': 'FO', // Faroese -> Faroe Islands
  'fj': 'FJ', // Fijian -> Fiji
  'tl': 'PH', // Filipino -> Philippines
  'fi': 'FI', // Finnish -> Finland
  'fon': 'BJ', // Fon -> Benin
  'fr': 'FR', // French -> France
  'fy': 'NL', // Frisian -> Netherlands
  'fur': 'IT', // Friulian -> Italy
  'ff': 'SN', // Fulani -> Senegal
  'gaa': 'GH', // Ga -> Ghana
  'gl': 'ES', // Galician -> Spain
  'ka': 'GE', // Georgian -> Georgia
  'de': 'DE', // German -> Germany
  'el': 'GR', // Greek -> Greece
  'gn': 'PY', // Guarani -> Paraguay
  'gu': 'IN', // Gujarati -> India
  'ht': 'HT', // Haitian Creole -> Haiti
  'cnh': 'MM', // Hakha Chin -> Myanmar
  'ha': 'NG', // Hausa -> Nigeria
  'haw': 'US', // Hawaiian -> United States
  'iw': 'IL', // Hebrew -> Israel
  'hil': 'PH', // Hiligaynon -> Philippines
  'hi': 'IN', // Hindi -> India
  'hmn': 'CN', // Hmong -> China
  'hu': 'HU', // Hungarian -> Hungary
  'hrx': 'BR', // Hunsrik -> Brazil
  'iba': 'MY', // Iban -> Malaysia
  'is': 'IS', // Icelandic -> Iceland
  'ig': 'NG', // Igbo -> Nigeria
  'ilo': 'PH', // Ilocano -> Philippines
  'id': 'ID', // Indonesian -> Indonesia
  'ga': 'IE', // Irish -> Ireland
  'it': 'IT', // Italian -> Italy
  'jam': 'JM', // Jamaican Patois -> Jamaica
  'ja': 'JP', // Japanese -> Japan
  'jv': 'ID', // Javanese -> Indonesia
  'kac': 'MM', // Jingpo -> Myanmar
  'kl': 'GL', // Kalaallisut -> Greenland
  'kn': 'IN', // Kannada -> India
  'kr': 'NG', // Kanuri -> Nigeria
  'pam': 'PH', // Kapampangan -> Philippines
  'kk': 'KZ', // Kazakh -> Kazakhstan
  'kha': 'IN', // Khasi -> India
  'km': 'KH', // Khmer -> Cambodia
  'cgg': 'UG', // Kiga -> Uganda
  'kg': 'CD', // Kikongo -> Democratic Republic of Congo
  'rw': 'RW', // Kinyarwanda -> Rwanda
  'ktu': 'CG', // Kituba -> Republic of Congo
  'trp': 'IN', // Kokborok -> India
  'kv': 'RU', // Komi -> Russia
  'gom': 'IN', // Konkani -> India
  'ko': 'KR', // Korean -> South Korea
  'kri': 'SL', // Krio -> Sierra Leone
  'ku': 'TR', // Kurdish (Kurmanji) -> Turkey
  'ckb': 'IQ', // Kurdish (Sorani) -> Iraq
  'ky': 'KG', // Kyrgyz -> Kyrgyzstan
  'lo': 'LA', // Lao -> Laos
  'ltg': 'LV', // Latgalian -> Latvia
  'la': 'VA', // Latin -> Vatican City
  'lv': 'LV', // Latvian -> Latvia
  'lij': 'IT', // Ligurian -> Italy
  'li': 'NL', // Limburgish -> Netherlands
  'ln': 'CD', // Lingala -> Democratic Republic of Congo
  'lt': 'LT', // Lithuanian -> Lithuania
  'lmo': 'IT', // Lombard -> Italy
  'lg': 'UG', // Luganda -> Uganda
  'luo': 'KE', // Luo -> Kenya
  'lb': 'LU', // Luxembourgish -> Luxembourg
  'mk': 'MK', // Macedonian -> North Macedonia
  'mad': 'ID', // Madurese -> Indonesia
  'mai': 'IN', // Maithili -> India
  'mak': 'ID', // Makassar -> Indonesia
  'mg': 'MG', // Malagasy -> Madagascar
  'ms': 'MY', // Malay -> Malaysia
  'ms-Arab': 'MY', // Malay (Jawi) -> Malaysia
  'ml': 'IN', // Malayalam -> India
  'mt': 'MT', // Maltese -> Malta
  'mam': 'GT', // Mam -> Guatemala
  'gv': 'IM', // Manx -> Isle of Man
  'mi': 'NZ', // Maori -> New Zealand
  'mr': 'IN', // Marathi -> India
  'mh': 'MH', // Marshallese -> Marshall Islands
  'mwr': 'IN', // Marwadi -> India
  'mfe': 'MU', // Mauritian Creole -> Mauritius
  'chm': 'RU', // Meadow Mari -> Russia
  'mni-Mtei': 'IN', // Meiteilon (Manipuri) -> India
  'min': 'ID', // Minang -> Indonesia
  'lus': 'IN', // Mizo -> India
  'mn': 'MN', // Mongolian -> Mongolia
  'my': 'MM', // Myanmar (Burmese) -> Myanmar
  'nhe': 'MX', // Nahuatl (Eastern Huasteca) -> Mexico
  'ndc-ZW': 'ZW', // Ndau -> Zimbabwe
  'nr': 'ZA', // Ndebele (South) -> South Africa
  'new': 'NP', // Nepalbhasa (Newari) -> Nepal
  'ne': 'NP', // Nepali -> Nepal
  'bm-Nkoo': 'GN', // NKo -> Guinea
  'no': 'NO', // Norwegian -> Norway
  'nus': 'SS', // Nuer -> South Sudan
  'oc': 'FR', // Occitan -> France
  'or': 'IN', // Odia (Oriya) -> India
  'om': 'ET', // Oromo -> Ethiopia
  'os': 'RU', // Ossetian -> Russia
  'pag': 'PH', // Pangasinan -> Philippines
  'pap': 'CW', // Papiamento -> Curaçao
  'ps': 'AF', // Pashto -> Afghanistan
  'fa': 'IR', // Persian -> Iran
  'pl': 'PL', // Polish -> Poland
  'pt': 'BR', // Portuguese (Brazil) -> Brazil
  'pt-PT': 'PT', // Portuguese (Portugal) -> Portugal
  'pa': 'IN', // Punjabi (Gurmukhi) -> India
  'pa-Arab': 'PK', // Punjabi (Shahmukhi) -> Pakistan
  'qu': 'PE', // Quechua -> Peru
  'kek': 'GT', // Qʼeqchiʼ -> Guatemala
  'rom': 'RO', // Romani -> Romania
  'ro': 'RO', // Romanian -> Romania
  'rn': 'BI', // Rundi -> Burundi
  'ru': 'RU', // Russian -> Russia
  'se': 'NO', // Sami (North) -> Norway
  'sm': 'WS', // Samoan -> Samoa
  'sg': 'CF', // Sango -> Central African Republic
  'sa': 'IN', // Sanskrit -> India
  'sat-Latn': 'IN', // Santali -> India
  'gd': 'GB', // Scots Gaelic -> United Kingdom
  'nso': 'ZA', // Sepedi -> South Africa
  'sr': 'RS', // Serbian -> Serbia
  'st': 'LS', // Sesotho -> Lesotho
  'crs': 'SC', // Seychellois Creole -> Seychelles
  'shn': 'MM', // Shan -> Myanmar
  'sn': 'ZW', // Shona -> Zimbabwe
  'scn': 'IT', // Sicilian -> Italy
  'szl': 'PL', // Silesian -> Poland
  'sd': 'PK', // Sindhi -> Pakistan
  'si': 'LK', // Sinhala -> Sri Lanka
  'sk': 'SK', // Slovak -> Slovakia
  'sl': 'SI', // Slovenian -> Slovenia
  'so': 'SO', // Somali -> Somalia
  'es': 'ES', // Spanish -> Spain
  'su': 'ID', // Sundanese -> Indonesia
  'sus': 'GN', // Susu -> Guinea
  'sw': 'KE', // Swahili -> Kenya
  'ss': 'SZ', // Swati -> Eswatini
  'sv': 'SE', // Swedish -> Sweden
  'ty': 'PF', // Tahitian -> French Polynesia
  'tg': 'TJ', // Tajik -> Tajikistan
  'ber-Latn': 'MA', // Tamazight -> Morocco
  'ber': 'MA', // Tamazight (Tifinagh) -> Morocco
  'ta': 'IN', // Tamil -> India
  'tt': 'RU', // Tatar -> Russia
  'te': 'IN', // Telugu -> India
  'tet': 'TL', // Tetum -> East Timor
  'th': 'TH', // Thai -> Thailand
  'bo': 'CN', // Tibetan -> China
  'ti': 'ET', // Tigrinya -> Ethiopia
  'to': 'TO', // Tongan -> Tonga
  'ts': 'ZA', // Tsonga -> South Africa
  'tn': 'BW', // Tswana -> Botswana
  'tr': 'TR', // Turkish -> Turkey
  'tk': 'TM', // Turkmen -> Turkmenistan
  'tw': 'GH', // Twi -> Ghana
  'udm': 'RU', // Udmurt -> Russia
  'uk': 'UA', // Ukrainian -> Ukraine
  'ur': 'PK', // Urdu -> Pakistan
  'ug': 'CN', // Uyghur -> China
  'uz': 'UZ', // Uzbek -> Uzbekistan
  've': 'ZA', // Venda -> South Africa
  'vec': 'IT', // Venetian -> Italy
  'vi': 'VN', // Vietnamese -> Vietnam
  'war': 'PH', // Waray -> Philippines
  'cy': 'GB', // Welsh -> United Kingdom
  'wo': 'SN', // Wolof -> Senegal
  'xh': 'ZA', // Xhosa -> South Africa
  'sah': 'RU', // Yakut -> Russia
  'yi': 'IL', // Yiddish -> Israel
  'yo': 'NG', // Yoruba -> Nigeria
  'yua': 'MX', // Yucatec Maya -> Mexico
  'zap': 'MX', // Zapotec -> Mexico
  'zu': 'ZA', // Zulu -> South Africa
};
